import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api_comm from "../../common/lib";

export const getStyle = createAsyncThunk(
	"config/Style",
	async (args, { getState }) => {
		const state = getState();

		try {
			let style = await api_comm("get", `/site/api/v2/styles`, {});

			return style.data.incentive_styles;
		} catch (e) {
			if (e.data.error) {
				console.log(e.data.data.error);
			}
			console.log("Error:::", e);
			return e?.message;
		}
	}
);

const initialState = {
	Style: null,
	loading: true,
};

export const StyleSlice = createSlice({
	name: "Style",
	initialState,
	reducers: {
		setStyle: (state, action) => {
			state.NavLinks = action.payload;
		},
	},
	extraReducers: {
		[getStyle.pending]: (state, action) => {
			state.loading = true;
		},
		[getStyle.fulfilled]: (state, action) => {
			// console.log("action.payload style==> ", action.payload);
			state.Style = action.payload;
			state.loading = false;
		},
		[getStyle.rejected]: (state, action) => {
			state.error = action.payload;
			state.loading = false;
		},
	},
});

export const { setStyle } = StyleSlice.actions;

export default StyleSlice.reducer;
